import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import moment from 'moment'
import { GetBrandedBadgingCertificate } from '../../../../services/BrandingService';
import { createLocalI18n } from '../../../../i18n/i18n';

export default function BadgeCertificate(props) {
  const {
      locale,
      recipient,
      awardedAt,
      description,
      rewardLevelId,
      width=1100,
      height=850,
      baseFontSize=40,
      isColorPrint=true,
  } = props;

  const i18nLanguage = locale.split('_')[0].toLowerCase();
  const i18n = useMemo(() => createLocalI18n(i18nLanguage), [i18nLanguage]);
  const {t} = useTranslation("badge_certificate", {i18n});

  const certImageSrc = GetBrandedBadgingCertificate(rewardLevelId, locale, !isColorPrint);
  const dateString = moment(awardedAt).locale(i18nLanguage).format('LL');

  const wrapperStyle = {...styles.wrapper};
  wrapperStyle.width = width;
  wrapperStyle.height = height;
  wrapperStyle.fontSize = baseFontSize;

  const titleStyle = {...styles.title};
  titleStyle.color = titleColors[rewardLevelId];
  if (!isColorPrint) titleStyle.color = 'black';

  const dividerStyle = {...styles.divider}
  if (!isColorPrint) dividerStyle.background = 'black';

  return (
    <div style={wrapperStyle}>
      <img src={certImageSrc} style={styles.certImage} />
      <div style={titleStyle}>{t("your_award")}</div>
      <div style={styles.recipient}>{recipient}</div>
      <div style={dividerStyle} />
      <div style={styles.awarder}>{t("honors_you_for")}:</div>
      <div style={styles.description}>{description}</div>
      <div style={styles.date}>{t("achieved")}: {dateString}</div>
    </div>
  )
}

const titleColors = {
  PAL: '#2DD9D9',
  BUDDY: '#407CFF',
  RANGER: '#05BEE8',
  TITAN: '#BF2817',
  GURU: '#CC5ACC',
  WIZARD: '#8CD43E',
}

// styles are inline because certs are printed in a tab without access to stylesheets
// see CertificatePrintWrapper's printCertificates function

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    pageBreakAfter: 'always',
    position: 'relative',
    fontFamily: 'Quicksand',
    fontWeight: '600',
  },
  certImage: {
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
  title: {
    position: 'absolute',
    top: '8%',
    fontSize: '120%',
    fontWeight: 700,
    letterSpacing: 1,
  },
  recipient: {
    position: 'absolute',
    top: '18%',
    fontSize: '115%',
    fontWeight: '700',
  },
  divider: {
    position: 'absolute',
    top: '27%',
    width: '50%',
    height: '0.6%',
    background: '#734699',
  },
  awarder: {
    position: 'absolute',
    top: '34%',
  },
  description: {
    position: 'absolute',
    top: '50%',
    fontWeight: '500',
    maxWidth: '40%',
  },
  date: {
    position: 'absolute',
    bottom: '8%',
    fontWeight: '500',
    fontSize: '75%',
  },
}